/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  Box,
  Button,
  Center,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  // FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalContent,
  //   InputLeftAddon,
  Select,
  SimpleGrid,
  Textarea,
} from '@chakra-ui/react'
import PersonalDetailsHeader from 'Components/Headers/PersonalDetailsHeader'
import Layout from 'Components/Layout'
import { USER_BROKER_TYPE, emailRegex, nameRegex } from 'Constants'
// import { USER_ID } from 'Constants';
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  useGetBankNamesQuery,
  useLazyGetNetworkManagerQuery,
  useLogoutUserMutation,
  useUpdatePersonalDetailsMutation,
} from 'Services/API/posp.api'
import { ToastService } from 'Services/toast.service'
import axios from 'axios'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { useOnClickOutside } from 'app/hooks/useClickOutside'
import { format, parse } from 'date-fns'
import { alphaNumericRegex, ifscRegex } from 'Constants/regex'
import { useDeviceType } from 'app/hooks'
import { useIdleTimer } from 'react-idle-timer'
import { userState } from 'Constants/userRegistrationStatus'
import { resetUser, updateUserState } from 'features/Authentication'
import { CITY_LIST, STATE_LIST } from 'Constants/constant'

const PersonalDetails = () => {
  const [apiValidations, setApiValidations] = useState<any>({})
  const [pincode, setPincode] = useState<any>('201301')
  const [pinCodeValues, setPinCodeValues] = useState<any>([])
  const [isRefCodeWrong, setIsRefcodeWrong] = useState<any>(false)
  const store = useSelector((state: any) => state.user)
  const navigate = useNavigate()
  const { broker } = store
  const [searchPincode, setSearchPincode] = useState('')
  const [searchBankName, setSearchBankName] = useState('')
  const [bankName, setBankName] = useState('')
  const [networkManager, setNetworkManager] = useState<any>('')
  const [pinCodeBlur, setPinCodeBlur] = useState<boolean>(false)
  const [bankNameBlur, setBankNameBlur] = useState<boolean>(false)
  const [managerId, setManagerId] = useState('')
  const [bankNames, setBankNames] = useState([])

  const { isLoggedIn, authenticatedUser } = useSelector((state: any) => state.user)
  // const dispatch = useDispatch()
  // const location = useLocation()
  // LOGOUT FUNCTIONALITIES

  // const [logoutUser] = useLogoutUserMutation({})

  // const handleLogout = async () => {
  //   try {
  //     const logoutUserResp = await logoutUser({
  //       idle: true,
  //     })
  //     // console.log(logoutUserResp)
  //     if (logoutUserResp?.data?.status && isLoggedIn) {
  //       ToastService.showInfoToast({
  //         title: 'Session Timeout',
  //         message: 'You have been auto logout due to inactivity',
  //       })
  //       navigate('/')
  //       localStorage.clear()
  //       sessionStorage.clear()
  //       dispatch(resetUser())
  //       dispatch(updateUserState(userState))
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }
  // // IDLE TIMER FOR AUTO LOGOUT
  // const [state, setState] = useState<string>('Active')
  // const [count, setCount] = useState<number>(0)
  // const [remaining, setRemaining] = useState<number>(0)

  // const onIdle = () => {
  //   // setState('Idle')
  //   handleLogout()
  // }

  // const onActive = () => {
  //   setState('Active')
  // }

  // const onAction = () => {
  //   setCount(count + 1)
  // }

  // const { getRemainingTime } = useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onAction,
  //   timeout: 10_000 * 6 * 5,
  //   throttle: 500,
  // })

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRemaining(Math.ceil(getRemainingTime() / 1000))
  //   }, 500)

  //   return () => {
  //     clearInterval(interval)
  //   }
  // })

  const [
    getNetworkManager,
    //  { isLoading: getNetworkManagerLoading }
  ] = useLazyGetNetworkManagerQuery()
  const pinCodeRef = useRef(null)
  const bankNameRef = useRef(null)
  const { isMobile } = useDeviceType()

  useOnClickOutside(pinCodeRef, () => {
    if (pincode.length !== 6) {
      setSearchPincode('')
    } else {
      setPinCodeBlur(false)
      // setApiValidations({...apiValidations, pincode: null})
    }
  })

  // console.log('bank name blur: ', bankNameBlur)
  useOnClickOutside(bankNameRef, () => {
    if (bankName.length) {
      setBankNameBlur(false)
    }

    setSearchBankName('')
  })

  const { data: bankNamesResponse, isLoading: bankNamesLoading } = useGetBankNamesQuery({})

  const handleFilter = async () => {
    if (searchBankName.length >= 3) {
      const allBankNames = bankNamesResponse?.data

      const filteredBankNames = await allBankNames.filter((value: { id: number; name: string }) => {
        const name = value.name.toLowerCase()
        const searchName = searchBankName.toLowerCase()
        return name.includes(searchName)
      })

      setBankNames(filteredBankNames)
    }
  }

  useEffect(() => {
    handleFilter()
  }, [bankNamesResponse, bankNamesLoading, searchBankName])

  const [updatePersonalDetails] = useUpdatePersonalDetailsMutation()

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    const {
      first_name,
      last_name,
      phone_no,
      pincode,
      email,
      address,
      dob,
      salutation,
      referral_code,
      ifsc_code,
      bank_name,
      bank_account_no,
    } = authenticatedUser
    reset({
      first_name,
      last_name,
      mobile_no: phone_no,
      email,
      address,
      dob,
      salutation,
      referral_code,
      ifsc_code,
      bank_name,
      bank_account_no,
      pincode,
      confirm_bank_account_no: bank_account_no,
    })
  }, [authenticatedUser])
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const getPinCodes = async () => {
    axios
      .get('https://cms.zopperinsurance.com/autofill/pincode', {
        method: 'GET',
        params: {
          pincode: searchPincode,
          insurance_id: '21',
        },
      })
      .then((res) => {
        if (res?.data?.data && res.data.data.length > 0) {
          const list = res?.data?.data.map((values: any) => ({
            name: values.pincode,
            city: values.city_name,
            area_name: values.area_name,
          }))
          setPinCodeValues(list)
        } else {
          setPincode(searchPincode)
        }
      })
      .catch((err) => setPincode(searchPincode))
  }

  useEffect(() => {
    getPinCodes()
  }, [searchPincode])

  const getRefinedPayload = (values: any) => {
    const obj: any = {}
    Object.keys(values).forEach((key) => {
      if (values[key]) {
        obj[key] = values[key].trim()
      }
    })

    return obj
  }

  const onSubmitPersonalDetails = async (values: any) => {
    // console.log('herer', values.confirm_bank_account_no !== values.bank_account_no)
    if (values.confirm_bank_account_no !== values.bank_account_no) {
      setApiValidations({
        ...apiValidations,
        confirm_bank_account_no: 'Account number and confirm account number must be identical',
      })
      return
    }

    try {
      const resp: any = await updatePersonalDetails(
        getRefinedPayload({
          ...values,
          pincode: pincode,
          manager_id: managerId ? managerId.toString() : '',
          manager_name: networkManager,
          bank_name: bankName,
        }),
      ).unwrap()
      ToastService.showSuccessTaost({ title: 'success', message: 'Data saved successfully' })
      navigate('/registration-status')
    } catch (err: any) {
      const ValidationErrors = err?.data?.data
      const apiError: any = {}
      if (ValidationErrors) {
        Object.keys(ValidationErrors).forEach((key) => {
          apiError[key] = ValidationErrors[key][0]
        })
        setApiValidations(apiError)
      }
    }
  }

  const debounce = (cb: any, delay = 1000) => {
    let timeout: any

    return (...args: any[]) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  }

  const handleRefcodeChange = debounce(async (e: any) => {
    try {
      const networkManagerResponse = await getNetworkManager({
        posp_id: e.target.value,
      }).unwrap()
      setNetworkManager(networkManagerResponse.data.manager_name)
      setManagerId(networkManagerResponse.data.manager_id)
    } catch (err) {
      setIsRefcodeWrong(true)

      setNetworkManager('')
      setManagerId('')
    }
  }, 1500)

  const preventCopyPaste = (e: any) => {
    e.preventDefault()
    ToastService.showInfoToast({
      title: 'Info says',
      message: 'Copying and pasting is not allowed!',
    })
  }

  // const handleDataChange = (field: string) => (e: any) => {
  //   setValues({ ...values, [field]: e.target.value });
  // };

  const { onChange, ...rest } = register('referral_code')

  return (
    <Layout HeaderComponent={<PersonalDetailsHeader />}>
      <form onSubmit={handleSubmit(onSubmitPersonalDetails)}>
        <SimpleGrid columns={{ md: 3 }} pt={6}>
          <Box borderRight={!isMobile ? '1px solid #D8D8D8' : 'none'} px={7}>
            <FormControl
              mb={5}
              isInvalid={
                !!errors.first_name ||
                !!errors.salutation ||
                !!apiValidations.salutation ||
                !!apiValidations.first_name
              }
            >
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                First Name
              </FormLabel>

              <InputGroup>
                <Select
                  {...register('salutation', {
                    required: 'This field is required',
                  })}
                  w='45%'
                  fontSize='xs'
                  placeholder='select'
                >
                  <option value='Mr'>Mr.</option>
                  <option value='Ms'>Ms.</option>
                  <option value='Mrs'>Mrs.</option>
                </Select>
                <Input
                  {...register('first_name', {
                    required: 'This field is required',
                    pattern: {
                      value: nameRegex,
                      message: 'Enter a valid name',
                    },
                  })}
                  type='text'
                  onChange={() => setApiValidations({ ...apiValidations, first_name: '' })}
                  placeholder='Enter First Name'
                />
              </InputGroup>
              <FormErrorMessage>
                {errors?.first_name?.message ??
                  errors?.salutation?.message ??
                  apiValidations.salutation ??
                  apiValidations.first_name}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb={5} isInvalid={!!errors.last_name || !!apiValidations.last_name}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Last Name
              </FormLabel>
              <Input
                {...register('last_name', {
                  required: 'This field is required',
                  pattern: {
                    value: nameRegex,
                    message: 'Enter a valid name',
                  },
                })}
                onChange={() => setApiValidations({ ...apiValidations, last_name: '' })}
                placeholder='Enter Name'
              />
              <FormErrorMessage>
                {(errors.last_name && `${errors.last_name.message}`) ||
                  (apiValidations.last_name && apiValidations.last_name)}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb={5} isInvalid={!!errors.dob || !!apiValidations.dob}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Date of Birth
              </FormLabel>
              <Input
                color='GrayText'
                {...register('dob', {
                  required: 'This field is required',
                  // validate: (value) => {
                  //   const selected = new Date(value).getFullYear()
                  //   const now = new Date().getFullYear()
                  //   return now - selected >= 18
                  // },
                })}
                type='date'
                max={format(
                  parse(
                    `${new Date().getFullYear() - 18}-${
                      new Date().getMonth() + 1
                    }-${new Date().getDate()}`,
                    'yyyy-MM-dd',
                    new Date(),
                  ),
                  'yyyy-MM-dd',
                )}
              />
              <FormErrorMessage>{errors?.dob?.message ?? apiValidations.dob}</FormErrorMessage>
            </FormControl>
            <FormControl mb={5} isInvalid={!!errors.mobile_no || !!apiValidations.mobile_no}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Mobile Number
              </FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents='none' color='#999999' fontSize='sm'>
                  +91
                </InputLeftElement>
                <Input
                  disabled
                  {...register('mobile_no', {
                    required: 'This field is required',
                  })}
                  type='text'
                />
              </InputGroup>
              <FormErrorMessage>
                {errors?.mobile_no?.message ?? apiValidations.mobile_no}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb={5} isInvalid={!!errors.email || !!apiValidations.email}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Email
              </FormLabel>
              <Input
                placeholder='Enter Email'
                {...register('email', {
                  required: 'This field is required',
                  pattern: {
                    value: emailRegex,
                    message: 'Enter a valid email',
                  },
                })}
                type='text'
              />
              <FormErrorMessage>{errors?.email?.message ?? apiValidations.email}</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={!!(pinCodeBlur && !pincode) || !!apiValidations.pincode}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Pincode
              </FormLabel>
              <Box position='relative' ref={pinCodeRef} mb={5}>
                <>
                  <Input
                    value={pincode || searchPincode}
                    placeholder='Enter more than 3 digits'
                    onChange={(e: any) => {
                      setSearchPincode(e.target.value)
                      setPincode('')
                    }}
                  />
                  <>
                    {pincode || searchPincode.length < 3
                      ? []
                      : pinCodeValues && (
                          <Box
                            border='1px solid #efefef'
                            borderRadius='7px'
                            position='absolute'
                            zIndex='10'
                            {...(isMobile ? { top: '45px' } : { bottom: '62px' })}
                            overflow='scroll'
                            w='full'
                            maxH='200px'
                            boxShadow='lg'
                          >
                            {pinCodeValues.map((item: any, index: number) => (
                              <Box
                                key={index}
                                onClick={(e: any) => {
                                  setPincode(item.name)
                                }}
                                fontSize='12px'
                                py='7px'
                                px='5px'
                                bg='white'
                                borderBottom='1px solid #efefef'
                              >
                                {`${item.name}, ${item.area_name}, ${item.city}`}
                              </Box>
                            ))}
                          </Box>
                        )}
                  </>
                  <FormErrorMessage>
                    {(!!(pinCodeBlur && !pincode) && 'This field is required') ||
                      apiValidations.pincode}
                  </FormErrorMessage>
                </>
              </Box>
            </FormControl>
          </Box>

          <Box borderRight={!isMobile ? '1px solid #D8D8D8' : 'none'} px={7}>
            <FormControl mb={5} isInvalid={!!errors.address || !!apiValidations.address}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Address
              </FormLabel>
              <Input
                {...register('address', {
                  required: 'This field is required',
                })}
                placeholder='Enter Address'
              />
              <FormErrorMessage>
                {errors?.address?.message ?? apiValidations.address}
              </FormErrorMessage>
            </FormControl>

            <FormControl mb={5} isInvalid={!!errors.city || !!apiValidations.city}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                City
              </FormLabel>
              <Input
                {...register('city', {
                  required: 'This field is required',
                })}
                placeholder='Enter City'
              />
              {/* <Select
                {...register('city', {
                  required: 'This field is required',
                })}
                placeholder='Select City'
              >
                {CITY_LIST.map((city: string) => (
                  <option key={city} value={city}>{city}</option>
                ))}
              </Select> */}
              <FormErrorMessage>{errors?.city?.message ?? apiValidations.city}</FormErrorMessage>
            </FormControl>

            <FormControl mb={5} isInvalid={!!errors.state || !!apiValidations.state}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                State
              </FormLabel>
              <Select
                {...register('state', {
                  required: 'This field is required',
                })}
                placeholder='Select State'
              >
                {STATE_LIST.map((state: string) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </Select>
              <FormErrorMessage>{errors?.state?.message ?? apiValidations.state}</FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!(bankNameBlur && !bankName) || !!apiValidations.bank_name}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Bank Name
              </FormLabel>
              <Box position='relative' className='hdt' ref={bankNameRef} mb={5}>
                <>
                  <Input
                    value={bankName || searchBankName}
                    placeholder='Enter more than 3 characters'
                    onChange={(e: any) => {
                      setSearchBankName(e.target.value)
                      setBankName('')
                    }}
                  />
                  <>
                    {bankName || searchBankName.length < 3
                      ? []
                      : bankNames && (
                          <Box
                            border='1px solid #efefef'
                            borderRadius='7px'
                            position='absolute'
                            zIndex='10'
                            {...(isMobile ? { top: '45px' } : { bottom: '62px' })}
                            overflow='scroll'
                            w='full'
                            maxH='200px'
                            boxShadow='lg'
                          >
                            {bankNames?.map((item: any, index: number) => (
                              <Box
                                key={index}
                                onClick={(e: any) => {
                                  setBankName(item.name)
                                }}
                                fontSize='12px'
                                py='7px'
                                px='5px'
                                bg='white'
                                borderBottom='1px solid #efefef'
                              >
                                {`${item.name}`}
                              </Box>
                            ))}
                          </Box>
                        )}
                  </>
                  <FormErrorMessage>
                    {(!!(bankNameBlur && !bankName) && 'This field is required') ||
                      apiValidations.bank_name}
                  </FormErrorMessage>
                </>
              </Box>
            </FormControl>

            <FormControl
              mb={5}
              isInvalid={!!errors.bank_account_no || !!apiValidations.bank_account_no}
            >
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Account Number
              </FormLabel>
              <Input
                {...register('bank_account_no', {
                  required: 'This field is required',
                  pattern: {
                    value: /^([0-9]\d*)(\.\d+)?$/,
                    message: 'Enter a valid account number',
                  },
                })}
                type='number'
                placeholder='Enter Account Number'
                onCopy={(e) => preventCopyPaste(e)}
                onCut={(e) => preventCopyPaste(e)}
              />
              <FormErrorMessage>
                {errors?.bank_account_no?.message ?? apiValidations.bank_account_no}
              </FormErrorMessage>
            </FormControl>
            <FormControl
              mb={5}
              isInvalid={
                !!errors.confirm_bank_account_no || !!apiValidations.confirm_bank_account_no
              }
            >
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Confirm Account Number
              </FormLabel>
              <Input
                type='number'
                {...register('confirm_bank_account_no', {
                  required: 'This field is required',
                })}
                placeholder='Enter Confirm Account Number'
                onPaste={(e) => preventCopyPaste(e)}
                onBlur={() => {
                  setApiValidations({ ...apiValidations, confirm_bank_account_no: '' })
                }}
              />
              <FormErrorMessage>
                {errors?.confirm_bank_account_no?.message ?? apiValidations.confirm_bank_account_no}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb={5} isInvalid={!!errors.ifsc_code || !!apiValidations.ifsc_code}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                IFSC Code
              </FormLabel>

              <Input
                {...register('ifsc_code', {
                  required: 'This field is required',
                  pattern: {
                    value: ifscRegex,
                    message: 'Enter a valid IFSC Code',
                  },
                })}
                type='text'
                placeholder='Enter IFSC Code'
              />
              <FormErrorMessage>
                {errors?.ifsc_code?.message ?? apiValidations.ifsc_code}
              </FormErrorMessage>
            </FormControl>
          </Box>

          <Box borderRight={!isMobile ? '1px solid #D8D8D8' : 'none'} px={7}>
            {/* <FormControl
              mb={2}
              isInvalid={!!errors.referral_code || !!apiValidations.referral_code}
            >
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Do you have a referral code?
              </FormLabel>

              <Input
                type='text'
                onChange={(e) => {
                  onChange(e)
                  handleRefcodeChange(e)
                }}
                {...rest}
                placeholder='Enter referral code'
              />
              <FormErrorMessage>
                {errors?.referral_code?.message ?? apiValidations.referral_code}
              </FormErrorMessage>
            </FormControl>
            <FormControl mt={5}>
              <FormLabel fontSize='sm' fontWeight={'semibold'}>
                Manager
              </FormLabel>

              <Input disabled value={networkManager} type='text' placeholder='' />
            </FormControl> */}
          </Box>
        </SimpleGrid>

        <Box mt={50}>
          <Center>
            <Button
              py={5}
              px={10}
              variant='outline'
              mr={4}
              size={'sm'}
              rounded='full'
              color={'#1C6DA2'}
              fontWeight={'normal'}
              onClick={() => navigate('/registration-status')}
            >
              BACK
            </Button>

            <Button
              rounded='full'
              py={5}
              px={10}
              fontWeight={'normal'}
              size={'sm'}
              type='submit'
              variant='solid'
              onClick={() => {
                setPinCodeBlur(true)
                setBankNameBlur(true)
              }}
            >
              VERIFY
            </Button>
          </Center>
        </Box>
      </form>
    </Layout>
  )
}

export default PersonalDetails
